import { getServerLogger } from "@/utils/logger";
import { createMiddleware } from "@tanstack/react-start";

export const loggingMiddleware = createMiddleware({ type: "function" }).server(
  async ({ next }) => {
    try {
      const result = await next();
      return result;
    } catch (e) {
      const logger = getServerLogger();
      logger.error(`Server function error ${e}`);
      throw e;
    }
  },
);
